export const  GET_GAME_HISTORY =  "GET_GAME_HISTORY"

export const RESET_COIN = "RESET_COIN"